module.exports = __webpack_public_path__ + "img/futurematrix.077589b1.svg";